import React, { useEffect, useRef, useState } from "react";
import INPUT from "../../Master/INPUT";
import BTN from "../../Master/BTN";
import MODEL from "../../Master/MODEL";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Breadcrumbs from "../../Utilities/BreadCrumbs/Breadcrumbs";
import {
  CALL_IC,
  CHECK_CIRCLE_IC,
  CLOSE_BLACK_IC,
  CLOSE_IC,
  CREDIT_CARD_IC,
  CURRENCY_IC,
  SCHEDULE_IC,
  SEARCH_IC,
  ACCOUNT_NAME,
  ACCOUNT_NUMBER,
  BANK_NAME,
  IFSC_CODE,
  BRANCH,
  dagabengalurulogoPNG,
} from "../../../assets";
import {
  useAddOrderMutation,
  useGetUserProfileQuery,
  useSendPaymentRequestMutation,
} from "../../../redux/slices/homeSlice";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isValidEmail } from "../../Footer/Footer";

const ShoppingTray = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const user = localStorage.getItem("user");
  const [isSelected, setIsSelected] = useState("shipping"); // billing, shipping, payment
  const [isStandardDelivery, setIsStandardDeliver] = useState(true);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("Cash");

  // ----------------------------- GET PROFILE DETAILS API CALLING -----------------------
  const [selectShippingAddressToggle, setSelectShippingAddressToggle] =
    useState(false);
  const [selectBillingAddressToggle, setSelectBillingAddressToggle] =
    useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);

  const myBagitems = useSelector((state) => state.myBagData.items);
  const orderDetails = useSelector((state) => state?.myBagData?.orderDetails);

  // const subTotal = myBagitems.reduce(
  //   (acc, item) =>
  //     acc + item.prices.price * item.quantity + (item?.lensDetails?.price || 0),
  //   0
  // );

  const subTotal = myBagitems?.reduce((total, item) => {
    // Calculate the product price based on quantity
    let productWeight = Number(item?.netWeight) * Number(item?.quantity);
    const finalWeight = Number(total) + productWeight;
    const final = finalWeight.toFixed(2);
    console.log(final);
    return final;
  }, 0);

  // const total = myBagitems.reduce(
  //   (acc, item) =>
  //     acc + item.prices.price * item.quantity + (item?.lensDetails?.price || 0),
  //   0
  // );

  // const total = myBagitems?.reduce(
  //   (acc, item) =>
  //     acc +
  //     item?.netWeight * item?.quantity,
  //   0
  // );

  // const calculateCouponOffer = (coupon) => {
  //   if (coupon) {
  //     if (coupon?.discountType?.type === "fixed") {
  //       return total - coupon?.discountType?.value;
  //     } else {
  //       return parseFloat(
  //         total - (total * coupon?.discountType?.value) / 100
  //       ).toFixed(2);
  //     }
  //   } else {
  //     return total;
  //   }
  // };

  const {
    data: customerProfileData,
    isSuccess: customerProfileDataIsSuccess,
    isLoading: customerProfileDataIsLoading,
    isError: customerProfileDataIsError,
    error: customerProfileDataError,
  } = useGetUserProfileQuery({ user: user }, { skip: !user });

  // --------------------------------- ADD ORDER HANDLE --------------------------------

  const [addOrderBody, setAddOrderBody] = useState(null);

  const shippingFormik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      address1: "",
      address2: "",
      zipCode: "",
      city: "",
      country: "",
      phone: "",
      email: "",
      label: "",
    },
    onSubmit: async function (values) {
      setAddOrderBody({
        ...addOrderBody,
        user_info: {
          firstname: values?.firstname,
          lastname: values?.lastname,
          email: values?.email,
          contact: values?.phone,
          address: selectedShippingAddress
            ? {
                ...selectedShippingAddress,
                address1: values?.address1,
                address2: values?.address2,
                city: values?.city,
                country: values?.country,
                firstname: values?.firstname,
                label: values?.label,
                lastname: values?.lastname,
                phone: values?.phone,
                zipCode: values?.zipCode,
              }
            : {
                address1: values?.address1,
                address2: values?.address2,
                city: values?.city,
                country: values?.country,
                firstname: values?.firstname,
                label: values?.label,
                lastname: values?.lastname,
                phone: values?.phone,
                zipCode: values?.zipCode,
              },
        },
      });
      setIsSelected("billing");

      window.scrollTo({
        top: 0,
        behavior: "smooth", // This makes the scroll smooth
      });
    },
    validate: (values) => {
      let errors = {};
      if (!values?.firstname) {
        errors.firstname = "First Name is Required!";
      } else if (!values?.lastname) {
        errors.lastname = "Last Name is Required!";
      } else if (!values?.address1) {
        errors.address1 = "Address One is Required!";
      } else if (!values?.zipCode) {
        errors.zipCode = "Pin Code is Required!";
      } else if (!values?.city) {
        errors.city = "City is Required!";
      } else if (!values?.country) {
        errors.country = "Country is Required!";
      } else if (!values?.phone) {
        errors.phone = "Phone Number is Required!";
      } else if (!/^[0-9]+$/i.test(values.phone)) {
        errors.phone = "Invalid Phone Number";
      } else if (values.phone.length !== 10) {
        errors.phone = "Phone Number must be 10 digits";
      }
      // else if (!values?.label) {
      //   errors.label = "Save As is Required!";
      // }
      return errors;
    },
  });

  const billingFormik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      address1: "",
      address2: "",
      zipCode: "",
      city: "",
      country: "",
      phone: "",
      email: "",
      label: "",
    },
    onSubmit: async function (values) {
      setAddOrderBody({
        ...addOrderBody,
        billing_info: {
          firstname: values?.firstname,
          lastname: values?.lastname,
          email: values?.email,
          contact: values?.phone,
          address: selectedBillingAddress
            ? {
                ...selectedBillingAddress,
                address1: values?.address1,
                address2: values?.address2,
                city: values?.city,
                country: values?.country,
                firstname: values?.firstname,
                label: values?.label,
                lastname: values?.lastname,
                phone: values?.phone,
                zipCode: values?.zipCode,
              }
            : {
                address1: values?.address1,
                address2: values?.address2,
                city: values?.city,
                country: values?.country,
                firstname: values?.firstname,
                label: values?.label,
                lastname: values?.lastname,
                phone: values?.phone,
                zipCode: values?.zipCode,
              },
        },
      });
      setIsSelected("payment");

      window.scrollTo({
        top: 0,
        behavior: "smooth", // This makes the scroll smooth
      });
    },
    validate: (values) => {
      let errors = {};
      if (!values?.firstname) {
        errors.firstname = "First Name is Required!";
      } else if (!values?.lastname) {
        errors.lastname = "Last Name is Required!";
      } else if (!values?.address1) {
        errors.address1 = "Address One is Required!";
      } else if (!values?.zipCode) {
        errors.zipCode = "Pin Code is Required!";
      } else if (!values?.city) {
        errors.city = "City is Required!";
      } else if (!values?.country) {
        errors.country = "Country is Required!";
      } else if (!values?.phone) {
        errors.phone = "Phone Number is Required!";
      } else if (!/^[0-9]+$/i.test(values.phone)) {
        errors.phone = "Invalid Phone Number";
      } else if (values.phone.length !== 10) {
        errors.phone = "Phone Number must be 10 digits";
      }
      // else if (!values?.label) {
      //   errors.label = "Save As is Required!";
      // }
      return errors;
    },
  });

  const [sameAsBilling, setSameAsBilling] = useState(false);

  const handleCheckboxChange = (e) => {
    setSameAsBilling(e.target.checked);
    if (e.target.checked) {
      billingFormik.setValues(shippingFormik.values);
      setSelectedBillingAddress(selectedShippingAddress);
    } else {
      billingFormik.resetForm();
      setSelectedBillingAddress(null);
    }
  };

  const billingAddressSelectHandle = (item) => {
    setSelectedBillingAddress(item);
    setSelectBillingAddressToggle(false);
    billingFormik.setValues({
      ...billingFormik.values,
      address1: item?.address1,
      address2: item?.address2,
      zipCode: item?.zipCode,
      phone: item?.phone,
      city: item?.city,
      country: item?.country,
      label: item?.label,
    });
  };

  const shippingAddressSelectHandle = (item) => {
    setSelectedShippingAddress(item);
    setSelectShippingAddressToggle(false);
    shippingFormik.setValues({
      ...shippingFormik.values,
      address1: item?.address1,
      address2: item?.address2,
      zipCode: item?.zipCode,
      phone: item?.phone,
      city: item?.city,
      country: item?.country,
      label: item?.label,
    });
  };

  useEffect(() => {
    if (customerProfileDataIsSuccess) {
      const { customer } = customerProfileData;
      shippingFormik.setFieldValue("firstname", customer?.firstname);
      shippingFormik.setFieldValue("lastname", customer?.lastname);
      shippingFormik.setFieldValue("email", customer?.email);
      setAddOrderBody({
        ...addOrderBody,
        cart: myBagitems?.map((item) => ({
          product_id: item?.product_id,
          name: item?.name,
          title: item?.name,
          images: item?.image,
          sku: item?.sku,
          quantity: item?.quantity,
          price: item?.prices.price,
          variants: [],
          attributes: item.attributes,
          orderStatus: selectedPaymentMode == "payzapp" ? "Pending" : "Placed",
          dagaCare: [],
          lensDetails:
            item?.lensDetails?.map((lens) => ({
              _id: lens?._id,
              name: lens?.name,
              lensCode: lens?.lensCode,
              type: lens?.type,
              price: lens?.price,
              category: lens?.category || "", // Adjust the category based on your data
              image: lens?.image,
              prescription: lens?.prescriptionDetail, // Assuming this holds prescription details
            })) || [],
        })),

        shippingOption: "daga",
        couponCode: "",
        paymentMethod: selectedPaymentMode,
        status: selectedPaymentMode === "payzapp" ? "Pending" : "Placed",
        subTotal: subTotal,
        shippingCost: 0,
        total: subTotal,
        dagaCashUsed: 0,
        discount: 0,
        customerId: customerProfileData?.customer?._id,
        checkoutType: "customer",
        isGift: orderDetails?.isGift,
        giftMessage: orderDetails?.giftMessage,
      });
    }
  }, [customerProfileDataIsSuccess, myBagitems, selectedPaymentMode]);

  const [addOrder] = useAddOrderMutation();
  const [sendPaymentRequest] = useSendPaymentRequestMutation();

  const addOrderHandle = () => {
    const paymentRequestBody = {
      amount: addOrderBody?.total,
      customer_id: addOrderBody?.customerId,
      customer_email: addOrderBody.user_info?.email,
      customer_phone: addOrderBody.user_info?.contact,
      first_name: addOrderBody.user_info?.firstname,
      last_name: addOrderBody.user_info?.lastname,
    };
    console.log("addOrderBody", addOrderBody);
    addOrder({
      body: addOrderBody,
      user: localStorage.getItem("user"),
    }).then((res) => {
      if (res?.data) {
        if (addOrderBody.paymentMethod === "payzapp") {
          sendPaymentRequest({
            body: { _id: res.data.data._id },
          }).then((res) => {
            if (res?.data) {
              if (res.data.status === "NEW") {
                var url = res.data.payment_links.web;
                return (window.location.href = url);
              }
            }
            if (res?.error) {
              console.log(res);
              return toast.error(`${res?.error?.data?.message}`);
            }
          });
        } else {
          toast.success(`Order placed successfully.`);
          navigate("/profile-details#order-history");
        }
      } else {
        toast.error(`${res?.error?.data?.message}`);
      }
    });
  };
  const [shoppingIsCompleted, setShoppingIsCompleted] = useState(false);
  const [billingIsCompleted, setBillingIsCompleted] = useState(false);
  useEffect(() => {
    shippingFormik?.values?.firstname !== "" &&
    shippingFormik?.values?.lastname !== "" &&
    shippingFormik?.values?.address1 !== "" &&
    shippingFormik?.values?.zipCode !== "" &&
    shippingFormik?.values?.city !== "" &&
    shippingFormik?.values?.country !== "" &&
    shippingFormik?.values?.phone !== "" &&
    shippingFormik?.values?.email !== ""
      ? // &&    shippingFormik?.values?.label !== ""
        setShoppingIsCompleted(true)
      : setShoppingIsCompleted(false);

    billingFormik?.values?.firstname !== "" &&
    billingFormik?.values?.lastname !== "" &&
    billingFormik?.values?.address1 !== "" &&
    billingFormik?.values?.zipCode !== "" &&
    billingFormik?.values?.city !== "" &&
    billingFormik?.values?.country !== "" &&
    billingFormik?.values?.phone !== "" &&
    billingFormik?.values?.email !== ""
      ? //  &&    billingFormik?.values?.label !== ""
        setBillingIsCompleted(true)
      : setBillingIsCompleted(false);
  }, [billingFormik, shippingFormik]);

  const isNotGo = () => {
    return myBagitems?.some((item) =>
      item?.quantity < item?.lensDetails?.length ? true : false
    );
  };

  return (
    <div className="w-full px-6 pb-6 bg-text_light_2">
      <div className="w-full">
        <Breadcrumbs
          breadcrumbs={[{ label: "Shopping Tray", link: "/shopping-bag" }]}
        />
      </div>
      <div className="w-full flex emd:flex-col lg:flex-row flex-wrap items-start justify-between">
        <div className="lg:w-[60%] emd:w-full small:w-full">
          {/* ============================ SHIPPING DETAILS =========================== */}
          <div className="w-full bg-bg_1 flex flex-col p-5 lato-regular">
            <div
              className="w-full flex items-center justify-between cursor-pointer"
              onClick={() =>
                setIsSelected(isSelected !== "shipping" ? "shipping" : "")
              }
            >
              <span className="text-xl text-primary cursor-pointer select-none lato-medium">
                1. Shipping Details
              </span>
              <div className="material-symbols-outlined text-2xl text-primary">
                {shoppingIsCompleted ? "check_circle" : "circle"}
              </div>
            </div>
            {isSelected === "shipping" && (
              <div className="w-full mt-7 flex flex-col items-start">
                <div className="w-full border-b border-text_dark_3 flex items-center">
                  <span
                    onClick={() => setIsStandardDeliver(true)}
                    className={` ${
                      isStandardDelivery ? "border-b-2 border-primary" : ""
                    } pb-3 select-none cursor-pointer text-text_dark_2`}
                  >
                    Standard Delivery
                  </span>
                  {/* <span
                    onClick={() => setIsStandardDeliver(false)}
                    className={` ${
                      !isStandardDelivery ? "border-b-2 border-primary" : ""
                    } pb-3 ms-7 select-none cursor-pointer `}
                  >
                    Collect in Store
                  </span> */}
                </div>
                {isStandardDelivery ? (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      shippingFormik.handleSubmit();
                    }}
                    className="w-full flex flex-col items-start"
                  >
                    <div className="w-full mt-3 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                      <INPUT
                        placeHolder={"First Name"}
                        mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                        name="firstname"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.firstname}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.firstname}
                        touched={shippingFormik.touched.firstname}
                      />
                      <INPUT
                        placeHolder={"Last Name"}
                        mainClass={
                          "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                        }
                        name="lastname"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.lastname}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.lastname}
                        touched={shippingFormik.touched.lastname}
                      />
                    </div>
                    <INPUT
                      placeHolder={"Address 1"}
                      mainClass={"mt-2"}
                      name="address1"
                      onChange={shippingFormik.handleChange}
                      val={shippingFormik.values.address1}
                      onBlur={shippingFormik.handleBlur}
                      errorMsg={shippingFormik.errors.address1}
                      touched={shippingFormik.touched.address1}
                      rComp={
                        user && (
                          <span
                            className="underline text-primary select-none cursor-pointer"
                            onClick={() => setSelectShippingAddressToggle(true)}
                          >
                            Select
                          </span>
                        )
                      }
                    />
                    <INPUT
                      placeHolder={"Address 2 (Optional)"}
                      mainClass={"mt-2"}
                      name="address2"
                      onChange={shippingFormik.handleChange}
                      val={shippingFormik.values.address2}
                      touched={shippingFormik.touched.address2}
                    />
                    <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                      <INPUT
                        placeHolder={"Pin code"}
                        mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                        name="zipCode"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.zipCode}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.zipCode}
                        touched={shippingFormik.touched.zipCode}
                      />
                      <INPUT
                        placeHolder={"City"}
                        mainClass={
                          "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                        }
                        name="city"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.city}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.city}
                        touched={shippingFormik.touched.city}
                      />
                    </div>

                    <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                      <INPUT
                        placeHolder={"Country"}
                        mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                        name="country"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.country}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.country}
                        touched={shippingFormik.touched.country}
                      />
                      <INPUT
                        placeHolder={"Email"}
                        mainClass={
                          "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                        }
                        name="email"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.email}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.email}
                        touched={shippingFormik.touched.email}
                      />
                    </div>

                    <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                      <INPUT
                        placeHolder={"Ph. No."}
                        mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                        name="phone"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.phone}
                        onBlur={shippingFormik.handleBlur}
                        errorMsg={shippingFormik.errors.phone}
                        touched={shippingFormik.touched.phone}
                      />

                      <INPUT
                        placeHolder={"Save as ( home, work )"}
                        mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                        name="label"
                        onChange={shippingFormik.handleChange}
                        val={shippingFormik.values.label}
                        onBlur={shippingFormik.handleBlur}
                        // errorMsg={shippingFormik.errors.label}
                        touched={shippingFormik.touched.label}
                      />
                    </div>

                    <BTN
                      title={"CONTINUE"}
                      bordered
                      type="submit"
                      onP={shippingFormik.handleSubmit}
                      className="border-primary text-base text-center px-1 rounded-none text-primary mt-7 w-[48%] py-1 "
                    />
                  </form>
                ) : (
                  <div className="flex flex-col items-start lg:w-[50%] emd:w-full small:w-full">
                    <span className="text-lg mt-10 ">Select Pick up store</span>
                    <INPUT
                      placeHolder={"Enter pincode/ location"}
                      mainClass={"mt-2"}
                      rComp={
                        <div className="material-symbols-outlined ">
                          <img src={SEARCH_IC} alt="" className="w-5" />
                        </div>
                      }
                    />
                    <div className="flex items-center mt-3 select-none">
                      <input
                        type="checkbox"
                        id="home_store"
                        className="cursor-pointer w-4 h-4 accent-primary "
                      />
                      <label
                        className="ms-2 cursor-pointer"
                        htmlFor="home_store"
                      >
                        Use My Home Store
                      </label>
                    </div>
                    <div className="p-3 mt-3 border border-light_secondary flex flex-col emd:w-full small:w-full lg:w-[95%]">
                      <div className="w-full flex items-center justify-between">
                        <span className="text-primary text-base">
                          My Home Store
                        </span>
                        <img
                          src={CLOSE_BLACK_IC}
                          alt=""
                          className="cursor-pointer"
                        />
                      </div>
                      <div className="mt-3">
                        Shop No 12, Nr Iskon Ambli Road, 384300 Lorem Ipsum
                      </div>
                      <div className="mt-3 flex justify-start items-center">
                        <div className="flex items-center">
                          <div className="material-symbols-outlined">
                            <img src={CALL_IC} alt="" className="w-5" />
                          </div>
                          <span className="ms-2">9903909083</span>
                        </div>
                        <div className="flex items-center ms-5">
                          <div className="material-symbols-outlined">
                            <img src={SCHEDULE_IC} alt="" className="w-5" />
                          </div>
                          <span className="ms-2">11:00 am 7:00 pm</span>
                        </div>
                      </div>
                    </div>
                    <BTN
                      title={"CONTINUE"}
                      bordered
                      className="border-primary text-base text-center px-1 rounded-none text-primary mt-10 w-[48%] py-1 "
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ============================ BILLING DETAILS =========================== */}
          <div className="w-full bg-bg_1 flex flex-col mt-5 p-5 lato-regular">
            <div
              className="w-full flex items-center justify-between cursor-pointer"
              onClick={() => {
                shoppingIsCompleted && shippingFormik.handleSubmit();
                shoppingIsCompleted &&
                  setIsSelected(isSelected !== "billing" ? "billing" : "");
              }}
              // onClick={() => {
              //   isSelected === "shipping"
              //     ? shippingFormik.handleSubmit()
              //     : setIsSelected(isSelected !== "billing" ? "billing" : "");
              // }}
            >
              <span className="text-xl text-primary cursor-pointer select-none lato-medium">
                2. Billing Details
              </span>
              <div className="material-symbols-outlined text-2xl text-primary">
                {billingIsCompleted ? "check_circle" : "circle"}
              </div>
            </div>
            {isSelected === "billing" && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  billingFormik.handleSubmit();
                }}
                className="w-full mt-7 flex flex-col items-start"
              >
                <div className="flex items-center select-none">
                  <input
                    type="checkbox"
                    id="same_as"
                    className="cursor-pointer w-4 h-4 accent-primary"
                    checked={sameAsBilling}
                    onChange={handleCheckboxChange}
                  />
                  <label className="ms-2 cursor-pointer" htmlFor="same_as">
                    Same as shipping details
                  </label>
                </div>
                <div className="w-full mt-3 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                  <INPUT
                    placeHolder={"First Name"}
                    mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                    name="firstname"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.firstname}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.firstname}
                    touched={billingFormik.touched.firstname}
                  />
                  <INPUT
                    placeHolder={"Last Name"}
                    mainClass={
                      "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                    }
                    name="lastname"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.lastname}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.lastname}
                    touched={billingFormik.touched.lastname}
                  />
                </div>
                <INPUT
                  placeHolder={"Address 1"}
                  mainClass={"mt-2"}
                  name="address1"
                  onChange={billingFormik.handleChange}
                  val={billingFormik.values.address1}
                  onBlur={billingFormik.handleBlur}
                  errorMsg={billingFormik.errors.address1}
                  touched={billingFormik.touched.address1}
                  rComp={
                    user && (
                      <span
                        className="underline text-primary select-none cursor-pointer"
                        onClick={() => setSelectBillingAddressToggle(true)}
                      >
                        Select
                      </span>
                    )
                  }
                />
                <INPUT
                  placeHolder={"Address 2 (Optional)"}
                  mainClass={"mt-2"}
                  name="address2"
                  onChange={billingFormik.handleChange}
                  val={billingFormik.values.address2}
                  touched={billingFormik.touched.address2}
                />
                <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                  <INPUT
                    placeHolder={"Pin code"}
                    mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                    name="zipCode"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.zipCode}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.zipCode}
                    touched={billingFormik.touched.zipCode}
                  />
                  <INPUT
                    placeHolder={"City"}
                    mainClass={
                      "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                    }
                    name="city"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.city}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.city}
                    touched={billingFormik.touched.city}
                  />
                </div>

                <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                  <INPUT
                    placeHolder={"Country"}
                    mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                    name="country"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.country}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.country}
                    touched={billingFormik.touched.country}
                  />
                  <INPUT
                    placeHolder={"Email"}
                    mainClass={
                      "lg:w-[48%] emd:w-full small:w-full small:mt-2 emd:mt-2 lg:mt-0"
                    }
                    name="email"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.email}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.email}
                    touched={billingFormik.touched.email}
                  />
                </div>

                <div className="w-full mt-2 flex lg:flex-row emd:flex-col small:flex-col items-center justify-between">
                  <INPUT
                    placeHolder={"Ph. No."}
                    mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                    name="phone"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.phone}
                    onBlur={billingFormik.handleBlur}
                    errorMsg={billingFormik.errors.phone}
                    touched={billingFormik.touched.phone}
                  />

                  <INPUT
                    placeHolder={"Save as ( home, work )"}
                    mainClass={"lg:w-[48%] emd:w-full small:w-full"}
                    name="label"
                    onChange={billingFormik.handleChange}
                    val={billingFormik.values.label}
                    onBlur={billingFormik.handleBlur}
                    // errorMsg={billingFormik.errors.label}
                    touched={billingFormik.touched.label}
                  />
                </div>
                <BTN
                  title={"CONTINUE"}
                  bordered
                  type="submit"
                  onP={billingFormik.handleSubmit}
                  className="border-primary text-base text-center px-1 rounded-none text-primary mt-7 w-[48%] py-1 "
                />
              </form>
            )}
          </div>
          {/* ============================ PAYMENT DETAILS =========================== */}
          <div className="w-full bg-bg_1 flex flex-col mt-5 p-5 lato-regular">
            <div
              className="w-full flex items-center justify-between cursor-pointer"
              onClick={() => {
                shoppingIsCompleted &&
                  billingIsCompleted &&
                  billingFormik.handleSubmit();
                shoppingIsCompleted &&
                  billingIsCompleted &&
                  setIsSelected(isSelected !== "payment" ? "payment" : "");
              }}
              // onClick={() => {
              //   isSelected === "billing"
              //     ? billingFormik.handleSubmit()
              //     : setIsSelected(
              //         isSelected !== "payment" ||
              //           (shoppingIsCompleted && billingIsCompleted)
              //           ? "payment"
              //           : ""
              //       );
              // }}
            >
              <span className="text-xl text-primary select-none lato-medium">
                3. Payment Details
              </span>
            </div>
            {isSelected === "payment" && (
              <div className="w-full mt-7 flex flex-col items-start">
                {/* <div className="w-full flex flex-col p-3 bg-white">
                  <span className="text-lg">Daga Pay</span>
                  <div className="w-full bg-bg_1 p-3 mt-3 flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-base">Available Points</span>
                      <span className="text-base">Points : 0.11</span>
                    </div>
                    <input
                      type="radio"
                      className="w-5 h-5 accent-primary cursor-pointer"
                      name="daga"
                      value="daga"
                      checked={selectedPaymentMode === "daga"}
                      onChange={(e) => setSelectedPaymentMode(e.target.value)}
                    />
                  </div>
                </div> */}
                <div className="w-full flex flex-col mt-4 p-3 bg-white">
                  {/* <div className="w-full flex flex-col">
                    <span className="text-lg">Payment Mode</span>
                    <div className="w-full bg-bg_1 p-3 mt-3 flex items-center justify-between">
                      <label
                        htmlFor="payzapp"
                        className="flex items-center cursor-pointer w-full"
                      >
                        <div className="material-symbols-outlined ">
                          <img src={CREDIT_CARD_IC} alt="" className="w-8" />
                        </div>
                        <span className="text-base ms-2">
                          Card / UPI / Net Banking
                        </span>
                      </label>
                      <input
                        id="payzapp"
                        type="radio"
                        className="w-5 h-5 accent-primary cursor-pointer"
                        name="payzapp"
                        value="payzapp"
                        checked={selectedPaymentMode === "payzapp"}
                        onChange={(e) => setSelectedPaymentMode(e.target.value)}
                      />
                    </div>
                  </div> */}
                  <div className="w-full flex flex-col">
                    <div className="w-full bg-bg_1 p-3 flex items-center justify-between">
                      <label
                        htmlFor="cash"
                        className="flex items-center w-full cursor-pointer"
                      >
                        <div className="material-symbols-outlined">
                          {/* <img src={CURRENCY_IC} alt="" className="w-8" /> */}
                        </div>
                        {/* <span className="text-base ms-2">COD</span> */}
                        <span className="text-lg ms-2">BANK DETAILS</span>
                      </label>
                      <input
                        id="cash"
                        type="radio"
                        className="w-5 h-5 accent-primary cursor-pointer"
                        name="Cash"
                        value="Cash"
                        checked={selectedPaymentMode === "Cash"}
                        onChange={(e) => setSelectedPaymentMode(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="w-full bg-bg_1 mt-4">
                    {/* <span className="text-lg">Bank Details</span> */}
                    <div className="w-full flex flex-col py-3 pl-4 ">
                      <span className="text-sm lm:text-base mb-1 flex flex-col lm:block">Account Name &nbsp;:&nbsp; <span className="font-bold text-primary">{ACCOUNT_NAME}</span></span>
                      <span className="text-sm lm:text-base mb-1 flex flex-col lm:block">Bank Name &nbsp;:&nbsp; <span className="font-bold text-primary">{BANK_NAME}</span></span>
                      <span className="text-sm lm:text-base mb-1 flex flex-col lm:block">Account No &nbsp;:&nbsp; <span className="font-bold text-primary">{ACCOUNT_NUMBER}</span></span>
                      <span className="text-sm lm:text-base mb-1 flex flex-col lm:block">IFSC Code &nbsp;:&nbsp; <span className="font-bold text-primary">{IFSC_CODE}</span></span>
                      <span className="text-sm lm:text-base mb-1 flex flex-col lm:block">Branch &nbsp;:&nbsp; <span className="font-bold text-primary">{BRANCH }</span></span>
                      <span className="text-xs lm:text-base text-primary mt-3">*Order will be recorded at the moment but will be accepted once the payment is verified by Daga-Gems.</span>
                    </div>
                  </div>
                </div>
                <BTN
                  title={"CONTINUE"}
                  bordered
                  className="text-base text-center px-1 rounded-none mt-10 w-[48%] py-1 border-primary text-primary "
                  onP={addOrderHandle}
                />
              </div>
            )}
          </div>
        </div>
        <div className="lg:w-[30%] emd:w-full small:w-full small:mt-5 emd:mt-5 lg:mt-0 bg-bg_1 flex flex-col p-5">
          <span className="text-xl text-text_dark_2 lato-medium">Order Summary</span>
          {myBagitems?.map((item, index) => {
            return <OrderSummaryProductCard key={index} product={item} />;
          })}
          <div className="w-full flex flex-col items-center mt-8 pb-3 border-b border-primary">
            <div className="w-full flex items-center justify-between text-text_dark_2 lato-regular">
              <span>Sub total</span>
              <span>{subTotal}&nbsp;g</span>
            </div>
            <div className="w-full flex items-center mt-2 justify-between text-text_dark_2 lato-regular">
              <span>Delivery</span>
              <span>Free</span>
            </div>
            {/* <div className="w-full flex items-center mt-2 justify-between text-text_dark_2">
              <span>Offer discount</span>
              <span>
                - ₹
                {Math.ceil(
                  parseFloat(
                    total - calculateCouponOffer(orderDetails?.couponCode)
                  )?.toFixed(2)
                )}
              </span>
            </div> */}
            {/* <div className="w-full flex items-center mt-2 justify-between">
              <span>Offer discount</span>
              <span>₹4470</span>
            </div> */}
          </div>
          <div className="w-full mt-3 flex items-center justify-between text-text_dark_2">
            <span className="lato-semibold text-lg">Total Net Weight</span>
            <span className="lato-bold text-lg">{subTotal}&nbsp;g</span>
          </div>
        </div>
      </div>
      {/* ============================== BILLING ADDRESS ====================== */}
      <MODEL
        showModel={selectBillingAddressToggle}
        setShowModel={setSelectBillingAddressToggle}
        title="Select Address"
      >
        <div className="w-full min-h-[60dh] max-h-[60dvh] overflow-auto p-10 grid lg:grid-cols-3 emd:grid-cols-2 small:grid-cols-1  auto-rows-auto gap-4 hide_scrollbar items-center">
          {customerProfileData?.customer?.addresses?.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => billingAddressSelectHandle(item)}
                className={` ${
                  item?._id === selectedBillingAddress?._id
                    ? "border border-primary"
                    : ""
                } bg-bg_1 p-4 overflow-hidden cursor-pointer select-none w-full h-44 justify-between flex flex-col`}
              >
                <div className="w-full flex justify-between items-center h-12 overflow-hidden">
                  <span className="text-lg font-bold h-full text-ellipsis">
                    {item?.firstname} {item?.label && ` (${item?.label})`}
                  </span>
                </div>
                <span className="text-base mt-2 w-full text-wrap truncate h-12 overflow-hidden text-ellipsis">
                  {item?.address1}, {item?.address2}
                </span>
                <div className="flex items-center mt-2">
                  <div className="material-symbols-outlined ">
                    <img src={CALL_IC} alt="" className="w-5" />
                  </div>
                  <span className="ms-1">{item?.phone}</span>
                </div>
              </div>
            );
          })}
        </div>
      </MODEL>

      {/* ============================== SHIPPING ADDRESS ====================== */}
      <MODEL
        showModel={selectShippingAddressToggle}
        setShowModel={setSelectShippingAddressToggle}
        title="Select Address"
      >
        <div className="w-full min-h-[60dh] max-h-[60dvh] overflow-auto p-10 grid lg:grid-cols-3 emd:grid-cols-2 small:grid-cols-1  auto-rows-auto gap-4 hide_scrollbar items-center">
          {customerProfileData?.customer?.addresses?.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => shippingAddressSelectHandle(item)}
                className={` ${
                  item?._id === selectedShippingAddress?._id
                    ? "border border-primary"
                    : ""
                } bg-bg_1 overflow-hidden p-4 cursor-pointer select-none w-full h-44 justify-between flex flex-col`}
              >
                <div className="w-full flex justify-between items-center h-12 overflow-hidden">
                  <span className="text-lg font-bold h-full text-ellipsis">
                    {item?.firstname} {item?.label && ` (${item?.label})`}
                  </span>
                </div>
                <span className="text-base mt-2 w-full text-wrap truncate h-12 overflow-hidden text-ellipsis">
                  {item?.address1}, {item?.address2}
                </span>
                <div className="flex items-center mt-2">
                  <div className="material-symbols-outlined text-xl">
                    <img src={CALL_IC} alt="" className="w-5" />
                  </div>
                  <span className="ms-1">{item?.phone}</span>
                </div>
              </div>
            );
          })}
        </div>
      </MODEL>
    </div>
  );
};

export default ShoppingTray;

function OrderSummaryProductCard({ product }) {
  const totalWithLens = product?.lensDetails?.reduce(
    (acc, lens) => acc + lens?.price,
    0
  );
  const [selectedShowPrescription, setSelectedShowPrescription] =
    useState(null);
  return (
    <div className="w-full flex flex-col bg-white mt-[25px] lato-regular">
      { product?.stock <= 0 && 
      <div className="new-arrival-label-mybag-card  bg-text_dark_3  text-white px-4 py-1 text-xs max-w-fit mt-3 mb-2 -ml-[6px] cursor-default">
        MAKE TO ORDER
      </div>
      } 
      <div className="flex w-full mb-3 px-4 pb-4">
        <div
          className="lg:min-w-[140px] lg:max-w-[140px] lg:min-h-[120px] lg:max-h-[120px]
    emd:min-w-[140px] emd:max-w-[140px] emd:min-h-[120px] emd:max-h-[120px]
    small:min-w-[120px] small:max-w-[120px] small:min-h-[100px] small:max-h-[100px]
     object-contain flex items-center justify-center overflow-hidden bg-bg_1 mt-4"
        >
          <img
            src={
              product?.image?.length > 0
                ? product?.image[0].replace(
                    "upload/",
                    "upload/if_w_gt_150/w_150/if_end/"
                  )
                : dagabengalurulogoPNG
            }
            className="w-[120px] h-full aspect-square object-contain p-2"
            alt=""
          />
        </div>
        <div className="lg:w-[calc(100%-140px)] emd:w-[calc(100%-140px)] small:w-[calc(100%-120px)] pl-4 flex flex-col mt-4">
          <div className="w-full flex lg:flex-row emd:flex-row mxs:flex-row lm:flex-row small:flex-col-reverse small:items-end emd:items-start lg:items-start justify-between">
            <span className="lg:text-lg emd:text-lg small:text-base">
              {product?.name}
            </span>
          </div>
          <span className="text-base">
            Quantity&nbsp;:&nbsp;{product?.quantity}
          </span>
          <span className="text-base">
            Net wt&nbsp;:&nbsp;{product?.netWeight}&nbsp;g
          </span>
        </div>
      </div>
      {product?.lensDetails?.length > 0 && (
        <div className="w-full flex flex-col">
          <div className=" w-full flex flex-col">
            <div className="text-base  uppercase">
              Lens Details ( {product?.lensDetails?.length} Lens )
            </div>
            {product?.lensDetails?.map((item, index) => {
              return (
                <div
                  onClick={() =>
                    setSelectedShowPrescription(item?.prescriptionDetail)
                  }
                  key={index}
                  className="w-full flex justify-between items-center mt-2 pb-2"
                >
                  <div className="flex items-center">
                    <span>{index + 1}.</span>
                    <span className="text-base ms-2 cursor-pointer">
                      {item.name + " Lens"} &nbsp;
                      <span className="text-nowrap">(₹ {item.price})</span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="w-full flex justify-between mt-2 border-t border-dashed border-light_secondary p-4 lato-regular">
        <span>Total Net Weight</span>
        <span className="text-base lato-medium">
          {Number(
            Number(product?.netWeight) * Number(product?.quantity)
          ).toFixed(2)}
          &nbsp;g
        </span>
      </div>

      {/* =================== PRESCRIPTION DETAILS MODEL =============== */}
      <MODEL
        setShowModel={() => setSelectedShowPrescription(null)}
        showModel={selectedShowPrescription !== null}
        isDialogue={true}
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full flex justify-between bg-bg_1 px-5 py-5">
            <span className=" text-xl ">Prescription details</span>
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="cursor-pointer"
              onClick={() => setSelectedShowPrescription(null)}
            />
          </div>
          <div className="w-full my-5 px-5">
            <div className="xl:flex-row emd:flex-row small:flex-col fix_lg:flex-col flex items-center justify-between">
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 flex flex-col justify-evenly items-center xl:border-r emd:border-r small:border-b fix_lg:border-b xl:border-b-0 emd:border-b-0 small:border-r-0 fix_lg:border-r-0 border-light_secondary  xl:pr-3 fix_lg:pr-0 emd:pr-3 small:pr-0 xl:pb-0 emd:pb-0 small:pb-2 fix_lg:pb-2">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Left Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.leftEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {selectedShowPrescription?.leftEye?.left_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.leftEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.leftEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 lg:pl-3 fix_lg:pl-0 emd:pl-3 small:pl-0 flex flex-col justify-evenly items-center">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Right Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.rightEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {item?.leftEye?.right_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.rightEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.rightEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </MODEL>
    </div>
  );
}

{
  /* <div className="w-full flex flex-col items-center mt-2 mb-2">
<div className="w-full flex flex-col items-start justify-between bg-white p-2">
  <div className="w-full flex items-start justify-between pb-2">
    <div className="w-1/2 overflow-hidden">
      <img
        src={product.image?.[0]?.replace(
          "upload/",
          "upload/if_w_gt_300/w_300/if_end/"
        )}
        alt=""
        className="w-[250px] h-[150px] object-contain"
      />
    </div>
    <div className="flex h-[150px] flex-col items-start justify-start w-[48%] overflow-hidden">
      <div className="flex flex-col">
        <span className="text-lg font-semibold">{product.name}</span>
        <span className="text-sm">SKU {product.sku}</span>
        <span className="text-sm mt-2">Qty {product.quantity}</span>
      </div>
      <div className="w-full mt-2 flex items-center">
        {product?.lensDetails?.price && (
          <span>₹{product.prices.price * product.quantity}</span>
        )}
      </div>
    </div>
  </div>
  <div className="w-full border-b border-light_secondary">
    {product?.lensDetails?.length > 0 && (
      <div className="w-full flex flex-col pb-2">
        <span className="mx-16 text-2xl">+</span>
        <div className=" w-full flex flex-col">
          <div className="py-1 text-base uppercase">Lens Details :</div>
          {product?.lensDetails?.map((item, index) => {
            return (
              <div
                key={index}
                className="w-full flex justify-between items-center pb-2 pr-5"
              >
                <div className="flex items-center">
                  <img
                    src={item?.image}
                    alt=""
                    className="min-w-[50px] max-w-[50px] bg-bg_1"
                  />
                  <span className="text-base ms-3">
                    {item?.name + " Lens"} &nbsp;
                    <span className="text-nowrap">(₹ {item?.price})</span>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )}
  </div>
  <div className="w-full mt-2 flex items-center justify-end">
    {product?.lensDetails?.price ? (
      <span>
        ₹
        {product.prices.price * product.quantity +
          product?.lensDetails?.price}
      </span>
    ) : (
      <span>₹{product.prices.price * product.quantity}</span>
    )}
  </div>
</div>
</div> */
}
